import AccountSetupLang from "./accountsetup";
import Countries from "./countries";
import CreateDealerLocationLang from "./createdealerlocation";
import CreateDealerUserLang from "./createdealeruser";
import CreateServiceCenterTech from "./createservicecentertech";
import CreateTicket from "./createticket";
import DataTableLang from "./datatable";
import DealershipInvitation from "./dealershipinvitation";
import DealershipLang from "./dealership";
import DealershipListLang from "./dealershiplist";
import DealershipLocationsLang from "./dealershiplocations";
import DealershipUsersLang from "./dealershipusers";
import Footer from "./footer";
import ForgotPasswordLang from "./forgotpassword";
import FormLang from "./form";
import Header from "./header";
import Languages from "./languages";
import LoginLang from "./login";
import Miscellaneous from "./misc";
import Modal from "./modal";
import MyAccount from "./myaccount";
import PasswordResetLang from "./resetpassword";
import ReportingDashboard from "./reportingdashboard";
import ServiceCenter from "./servicecenter";
import ServiceCenterList from "./servicecenterlist";
import Sidebar from "./sidebar";
import SignUpLang from "./signup";
import Ticket from "./ticket";
import TicketList from "./ticketlist";
import User from "./user";

const supportedLanguages = [
  "en",
  "es",
  "fr",
  "nl",
  "zh",
  "de",
  "jp",
  "it",
  "es-MX"
];
const registeredPages = [
  AccountSetupLang,
  Countries,
  CreateDealerLocationLang,
  CreateDealerUserLang,
  CreateServiceCenterTech,
  CreateTicket,
  DataTableLang,
  DealershipInvitation,
  DealershipLang,
  DealershipListLang,
  DealershipLocationsLang,
  DealershipUsersLang,
  Footer,
  ForgotPasswordLang,
  FormLang,
  Header,
  Languages,
  LoginLang,
  Miscellaneous,
  Modal,
  MyAccount,
  PasswordResetLang,
  ReportingDashboard,
  ServiceCenter,
  ServiceCenterList,
  Sidebar,
  SignUpLang,
  Ticket,
  TicketList,
  User
];

const lang = {};

const initializeSupportedLanguages = () => {
  for (const language of supportedLanguages) {
    lang[language] = {
      translation: {}
    };
  }
};

const registerPages = () => {
  for (const page of registeredPages) {
    for (const language of supportedLanguages) {
      lang[language].translation = {
        ...lang[language].translation,
        ...page[language]
      };
    }
  }
};

initializeSupportedLanguages();
registerPages();
export default lang;
